module.exports = __webpack_public_path__ + "static/media/logo_beta.d2e61541.png";